/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-template-component.reducer';

export const TreatmentTemplateComponentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentTemplateComponentEntity = useAppSelector(state => state.treatmentTemplateComponent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentTemplateComponentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.detail.title">TreatmentTemplateComponent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.name">Name</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.description">Description</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentTemplateComponentEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.approachType">Approach Type</Translate>
          </dt>
          <dd>{treatmentTemplateComponentEntity.approachType ? treatmentTemplateComponentEntity.approachType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.componentType">Component Type</Translate>
          </dt>
          <dd>{treatmentTemplateComponentEntity.componentType ? treatmentTemplateComponentEntity.componentType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentTemplateComponent.plan">Plan</Translate>
          </dt>
          <dd>{treatmentTemplateComponentEntity.plan ? treatmentTemplateComponentEntity.plan.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-template-component" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-template-component/${treatmentTemplateComponentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentTemplateComponentDetail;
